module.exports = __webpack_public_path__ + "img/icon_map_5_hg.91cbb20e.png";